export default __webpack_public_path__ + "static/0299-55c19f12f6924d724d013415cf900ea1.png";